module.exports = __webpack_public_path__ + "img/canvas_image_1.b2d94dd.jpg";